export type ConfirmationWithCommentDialogState = {
  isShow: boolean;
  type: string;
  title: string;
  subTitle?: string;
  onNgButtonClicked?: (clickOk: boolean, comment: string) => any;
  onOkButtonClicked?: (clickOk: boolean, comment: string) => any;
  message: string;
  layout: {
    showCloseButton: boolean;
    showCancelButton: boolean;
    cancelButtonTitle: string;
    showNgButton: boolean;
    ngButtonTitle: string;
    reqCommClickNg: boolean;
    okButtonTitle: string;
    reqCommClickOk: boolean;
  };
  comment: string;
  isValid: boolean;
};
export type PageNewState =
  | ConfirmationWithCommentDialogState
  | ((
      prevState: ConfirmationWithCommentDialogState,
    ) => ConfirmationWithCommentDialogState);
